import React from 'react';
import { callDeepLink } from '@croquiscom/web2app';
import { IconArrowRightRegular } from '@croquiscom-pvt/zds';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { useZigzag } from '@common/device-manager';
import { Typography } from '@common/styles';

import { useOptions } from '../../../queries/useOptions';

interface Props {
  className?: string;
}

// MEMO: 신발 or 의류가 아닌 관리 카테고리 ID. BE와 협의하여 카테고리 구분 방식 수정 필요.
const EXTRA_CATEGORY_ID_LIST = [2894, 2889, 2886, 2876, 2865, 2277, 718, 579, 507, 448];
const SHOES_CATEGORY_ID = 459;

export const GlobalSizeGuideButton: React.FC<React.PropsWithChildren<Props>> = ({ className }) => {
  const {
    options: {
      catalog_product: { category_list },
    },
  } = useOptions();
  const is_app = useZigzag();

  if (
    !is_app ||
    !category_list ||
    !category_list.length ||
    EXTRA_CATEGORY_ID_LIST.includes(category_list[0].category_id)
  ) {
    return null;
  }

  const tab = category_list[0]?.category_id === SHOES_CATEGORY_ID ? 'shoes' : 'clothes';

  const openGlobalSize = () => {
    callDeepLink('/simple_browser')({
      url: encodeURIComponent(`${window.location.origin}/products/global-size?tab=${tab}`),
    });
  };

  return (
    <SizeGuide type='button' onClick={openGlobalSize} className={cx(Typography.BODY_15_BOLD, className)}>
      사이즈 가이드
      <IconArrowRightRegular v3Color='gray900' width={16} height={16} />
    </SizeGuide>
  );
};

const SizeGuide = styled.button`
  width: auto;
  display: flex;
  align-items: center;
  margin: 5px 0 10px 20px;
  /* TODO: 옵션의 renderMoveToZigzinButton 추가시 조건부 스타일 적용 필요
  position: absolute;
  top: 28px; */
`;
